var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80005 7.44119V2.8H12.2V7.44119H13V2.5C13 2.22386 12.7761 2 12.5 2H3.5C3.22388 2 3 2.22386 3 2.5V7.44119H3.80005Z",
    fill: "#4E4E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8.99689H1V8.31426H4.90332L6.69543 4.08778L8.04321 9.08475L9.36121 5.08778L10.6375 8.31434H15V8.99698H13V13.5C13 13.7761 12.7761 14 12.5 14H3.5C3.22388 14 3 13.7761 3 13.5V8.99689ZM3.80005 8.99689V13.2H12.2V8.99698H10.0291L9.43872 7.50552L7.95667 12L6.50452 6.62013L5.4967 8.99689H3.80005Z",
    fill: "#4E4E4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80005 13.2V8.99687H5.4967L6.50452 6.62012L7.95667 12L9.43872 7.50551L10.0291 8.99696H12.2V13.2H3.80005Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartRate);
export default __webpack_public_path__ + "static/media/heart-rate.bcf0d3582850ad18c855a6bb64164f1b.svg";
export { ForwardRef as ReactComponent };